import { Button, Table, Tooltip } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";

function RecentProperty() {
  const users_list = useSelector((state) =>
    state?.allapi?.get_product_list ? state?.allapi?.get_product_list : {}
  );
  const [page, setPage] = useState(1);
  const listdata = users_list?.docs ? users_list?.docs?.slice(0, 4) : [];

  const navigate = useNavigate();
  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <div style={{ width: "100px" }}>
    //           <img
    //             style={{ width: "100%" }}
    //             src={URL?.API_BASE_URL + item?.featureImage}
    //             alt=""
    //           />
    //         </div>
    //       </>
    //     );
    //   },
    // },
    /* {
      title: "User Id",
      dataIndex: "referId",
      key: "referId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <span
              className="cursor-pointer coustomNevc"
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.referId}
            </span>
          </>
        );
      },
    }, */

    // {
    //   title: "Name",
    //   dataIndex: "title",
    //   key: "title",
    // },

    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Father/Husband",
      dataIndex: "fatharYaHusband",
      key: "fatharYaHusband",
    },
    {
      title: "Scheme",
      dataIndex: "skimName",
      key: "skimName",
    },
    {
      title: "transferred",
      dataIndex: "transferred",
      key: "transferred",
    },
    {
      title: "Recipt No",
      dataIndex: "rasidNo",
      key: "rasidNo",
    },
    {
      title: "number",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Schemedate",
      dataIndex: "Schemedate",
      key: "Schemedate",
    },
    // {
    //   title: "Scheme",
    //   dataIndex: "categoryDetails",
    //   key: "categoryDetails",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <span className="cursor-pointer">{item?.categorymainId?.name}</span>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button2 ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Actions",
    //   dataIndex: "action",
    //   key: "action",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title="Edit">
    //           <span
    //             className="cursor-pointer"
    //             onClick={() => navigate(`/update-product/${item?.pro_slug}`)}
    //           >
    //             <SvgIcon.Pencil className="scale-icon edit-icon" />
    //           </span>
    //         </Tooltip>
    //         <Tooltip title="Delete">
    //           <span
    //             className="cursor-pointer"
    //             onClick={() => {
    //               showDeleteConfirm(item?._id);
    //             }}
    //           >
    //             <SvgIcon.deletebtn className="scale-icon edit-icon" />
    //           </span>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
  ];
  return (
    <div>
      <div className="flex gap10 mt-30">
        <div className="col-6">
          <div className="opacity-8 fw-bold fs-16">Recent Property</div>
        </div>
        <div className=" col-6 text-right">
          <div className="flex1 flex justify-content-end align-items-center">
            <Tooltip title="  View All">
              <Button
                type="primary"
                className="jop_btn"
                onClick={() => navigate("/property")}
              >
                View All
              </Button>
            </Tooltip>
          </div>
        </div>
      </div>
      <div className="tableResponsive mt-10">
        <Table
          dataSource={listdata}
          columns={columns}
          className={"table antd_table"}
          pagination={{
            current: page,
            pageSize: 10,
            onChange(current, pageSize) {
              //   hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: 4 ? 4 : 0,
          }}
        />
      </div>
    </div>
  );
}

export default RecentProperty;
